import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4 3.75c-.827 0-1.5.673-1.5 1.5v4.5c0 .827.673 1.5 1.5 1.5h.75v1.125a.373.373 0 0 0 .6.3l1.9-1.425h3.5c.827 0 1.5-.673 1.5-1.5v-4.5c0-.827-.673-1.5-1.5-1.5zM10.75 12H8.5v.75c0 .827.673 1.5 1.5 1.5h2.75l1.9 1.425a.38.38 0 0 0 .394.035.37.37 0 0 0 .206-.335V14.25H16c.827 0 1.5-.673 1.5-1.5v-4.5c0-.827-.673-1.5-1.5-1.5h-3v3A2.25 2.25 0 0 1 10.75 12"
    }, null, -1)
  ]))]))
}
export default { render: render }